import { useEffect, useCallback } from 'react';
import { Grid, Stack, Title, Text } from '@mantine/core';
import { NodeMapView } from '../components/map/NodeMapView';
import { SensorActivityFeed } from '../components/SensorActivityFeed';
import { useStore } from '../store/useStore';

export function Map() {
  const fetchDevices = useStore((state) => state.fetchDevices);
  const fetchSensorObservations = useStore((state) => state.fetchSensorObservations);
  const sensorObservations = useStore((state) => state.sensorObservations);
  const sensorObservationsLoading = useStore((state) => state.sensorObservationsLoading);

  // Initial fetch
  useEffect(() => {
    fetchDevices();
    fetchSensorObservations();
  }, [fetchDevices, fetchSensorObservations]);

  // Polling for updates
  useEffect(() => {
    const interval = setInterval(() => {
      fetchDevices();
      fetchSensorObservations();
    }, 10000); // Poll every 10 seconds

    return () => clearInterval(interval);
  }, [fetchDevices, fetchSensorObservations]);

  const handleDeviceClick = useCallback(() => {
    // Navigate to devices page
    window.location.href = '/devices';
  }, []);

  return (
    <Stack gap="lg">
      <div>
        <Title order={1}>Node Map</Title>
        <Text c="dimmed" size="sm">
          View sensor node locations and activity feed
        </Text>
      </div>

      <Grid>
        {/* Map - takes 2/3 of the width */}
        <Grid.Col span={{ base: 12, md: 8 }}>
          <NodeMapView onDeviceClick={handleDeviceClick} />
        </Grid.Col>

        {/* Sensor Activity Feed - takes 1/3 of the width */}
        <Grid.Col span={{ base: 12, md: 4 }}>
          <SensorActivityFeed
            observations={sensorObservations}
            loading={sensorObservationsLoading}
          />
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
